import React, { useEffect, useState } from 'react'
import {
    Col,
    Row,
    Input,
    Form,
    Button,
    Select,
    Space,
    DatePicker,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import {
    type ManageUserDetailsFormDataInterface,
    type UserINFOFormStateInterface,
    type ManageUserDetailsFormInterface,
} from '../../../Types/ManageUser'
import PostCodeInput from '../../../Components/PostCodeInput'
import { connect, useDispatch } from 'react-redux'
import ActivePremission from '../../../Utils/premissins'
import { PermissionType } from '../../../Types/Enum/PermissionType'
import { SaveOutlined } from '@ant-design/icons'
import commonStyles from '../../../Utils/Common.less'
import dayjs from 'dayjs'
import S3Upload from '../../../Components/S3Upload'
import {
    GetCountryList,
    GetDYNAMICClientDetails,
} from '../../../Services/Common'
import { GetUserList } from '../../../Services/User'
import { GetCategoryDropDownList } from '../../../Services/GroupAndPartners'
import { type ListFrontEndInterface } from '../../../Types/CommonType'
import {
    GetDesignationDropDownList,
    SaveUserInfo,
} from '../../../Services/ManageUser'
import { UserInformationDefaultData } from './userInfoList'

const UserInfoForm = (
    props: ManageUserDetailsFormInterface
): React.ReactElement => {
    const {
        countryList,
        userList,
        categoryDropDownList,
        designationDropDownList,
        dynamicClientCategoryList,
        onSave,
        editData,
        setResetData,
        resetdata,
    } = props
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [clientDynamicId, setClientDynamicId] = useState<number | null>(null)
    const [dynamicName, setSelectedLabeldynamicClinet] = useState<string>('')
    const [isLoadingModal, setIsLoadingModal] = useState(false)
    const [selectedLabelManager, setSelectedLabelManager] = useState<string>('')
    const [selectedLabelcategory, setSelectedLabelcategory] =
        useState<string>('')
    const [selectedLabelDesignation, setSelectedLabelDesignation] =
        useState<string>('')
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })

    useEffect(() => {
        if (resetdata === 'true') {
            form.resetFields()
        }

        setResetData('false')
    }, [resetdata])
    useEffect(() => {
        if (address.line_1 !== '') {
            const AddressData = {
                town: address.post_town,
                country: address?.country?.toUpperCase() ?? '',
                postCode: address.postcode,
                addressOne: address?.line_1,
                addressTwo: address?.line_2,
            }

            form.setFieldsValue(AddressData)
        }
    }, [address])

    useEffect(() => {
        if (editData !== null) {
            const departmentData = dynamicClientCategoryList.find(
                (data: ListFrontEndInterface) =>
                    data?.label === editData?.clientDynCategoryName
            )
            setClientDynamicId(departmentData?.value ?? null)
        }
    }, [editData, dynamicClientCategoryList])

    useEffect(() => {
        GetCountryList(dispatch)
        GetUserList(dispatch)
        GetCategoryDropDownList(dispatch)
        GetDYNAMICClientDetails(dispatch)
    }, [])

    const handleDepartmentChange = (option: ListFrontEndInterface): void => {
        setClientDynamicId(form.getFieldValue('clientDynCategoryId'))
        setSelectedLabeldynamicClinet(option?.label)
    }

    useEffect(() => {
        if (clientDynamicId !== null && clientDynamicId !== undefined) {
            GetDesignationDropDownList(dispatch, clientDynamicId)
        }
    }, [clientDynamicId, editData, resetdata])

    useEffect(() => {
        const designationData = designationDropDownList.find(
            (data: ListFrontEndInterface) =>
                data?.label === editData?.designationName
        )
        const data = {
            clientDynCategoryId: clientDynamicId === 0 ? null : clientDynamicId,
            designationId:
                designationData?.value === 0
                    ? null
                    : (designationData?.value ?? null),
        }

        form.setFieldsValue(data)
    }, [designationDropDownList, resetdata])
    useEffect(() => {
        if (editData !== null && clientDynamicId !== undefined) {
            const designationData = designationDropDownList.find(
                (data: ListFrontEndInterface) =>
                    data?.label === editData?.designationName
            )
            const countryData = countryList.find(
                (data: ListFrontEndInterface) =>
                    data?.label === editData?.country
            )
            const newData = {
                ...editData,
                clientDynCategoryId:
                    clientDynamicId === 0 ? null : clientDynamicId,
                designationId:
                    designationData?.value === 0
                        ? null
                        : (designationData?.value ?? null),
                imageUrl: editData?.imageUrl,
                countryName: countryData?.value ?? '',
                userGroupId:
                    editData?.userGroupId === 0 ? null : editData?.userGroupId,
            }
            form.setFieldsValue(newData)
        }
    }, [editData, resetdata])

    const setFormData = (name: string, location: string): void => {
        form.setFieldValue(name, location)
    }

    useEffect(() => {
        setSelectedDate(editData?.dateOfBirth)
    }, [editData?.dateOfBirth, resetdata])

    const onChange = (
        date: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (date !== null && date !== undefined) {
            const isoDate = date.toISOString()

            setSelectedDate(isoDate)
            form.setFieldsValue({ dateOfBirth: date }) // Update form value
            void form.validateFields(['dateOfBirth'])
        }
    }

    const handleManagerChange = (option: ListFrontEndInterface): void => {
        setSelectedLabelManager(option?.label)
    }

    const handleCategoryChange = (option: ListFrontEndInterface): void => {
        setSelectedLabelcategory(option?.label)
    }

    const handleDesignationchanage = (option: ListFrontEndInterface): void => {
        setSelectedLabelDesignation(option?.label)
    }

    const saveuserInformationData = (): void => {
        void saveuserInformation()
    }
    const saveuserInformation = async (): Promise<void> => {
        try {
            await form.validateFields()
            const formData = form.getFieldsValue()
            setIsLoadingModal(true)

            const userGroupName =
                formData.userGroupId === 1
                    ? 'Super Admin'
                    : formData.userGroupId === 2
                      ? 'Admin'
                      : formData.userGroupId === 3
                        ? 'Manager'
                        : 'Employee'
            const datatosave = {
                userId: formData.userId ?? 0,
                firstName: formData.firstName,
                middleName: formData.middleName,
                surName: formData.surName,
                dateOfBirth: dayjs(formData.dateOfBirth).format('DD/MM/YYYY'),
                addressOne: formData.addressOne,
                addressTwo: formData.addressTwo,
                town: formData.town,
                country: formData.country,
                postCode: formData.postCode,
                userName: formData.userName,
                imageUrl:
                    formData.imageUrl ??
                    'https://iykons-s3-storage.s3.eu-west-1.amazonaws.com/Document/UserImage/no-image.png',
                emailAddress: formData.emailAddress,
                contactNo: formData.contactNo,
                managerId: formData.managerId,
                managerName: selectedLabelManager,
                workingStatus: 'Acitve',
                userGroupId: formData.userGroupId,
                userGroupName,
                clientCategoryId: formData.clientCategoryId,
                clientCategoryName: selectedLabelcategory,
                departmentId: 0,
                departmentName: '',
                designationId: formData.designationId,
                designationName: selectedLabelDesignation,
                isActive: '',
                isDelete: '',
                isActivated: editData.isActivated,
                clientDynCategoryName: dynamicName ?? '',
                clientDynCategoryId: formData.clientDynCategoryId,
            }

            void saveUserInfoData(datatosave)
        } catch (error) {}
    }

    const saveUserInfoData = async (
        data: ManageUserDetailsFormDataInterface
    ): Promise<void> => {
        await SaveUserInfo(dispatch, data)
            .then((result) => {
                if (result !== null && result !== undefined) {
                    onSave(resetForm)
                    setIsLoadingModal(false)
                }
            })
            .catch(() => {})
    }

    const resetForm = (): void => {
        form.setFieldsValue({
            UserInformationDefaultData,
            clientCategoryId: null,
            designationId: null,
        })
        setSelectedDate('')
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    return (
        <div className={commonStyles.formWrapper}>
            <Form
                name="complex-form"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                layout={'vertical'}
                autoComplete="off"
                form={form}
                requiredMark={customizeRequiredMark}
            >
                <Form.Item<ManageUserDetailsFormDataInterface>
                    name="userId"
                    hidden={true}
                >
                    <Input />
                </Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Group & Partners"
                            name="clientCategoryId"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Please Input Your Group & Partners!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder="Please select"
                                onChange={handleCategoryChange}
                                filterOption={(input, option) =>
                                    !(option == null) &&
                                    option?.label
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                options={[
                                    { label: 'Please select', value: null },
                                    ...categoryDropDownList,
                                ]}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Client Category"
                            name="clientDynCategoryId"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter Client Category',
                                },
                            ]}
                            // label="Department"
                            // name="clientDynCategoryId"
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: 'Please Input Your Department!',
                            //     },
                            // ]}
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={handleDepartmentChange}
                                options={[
                                    { label: 'Please Select', value: null },
                                    ...dynamicClientCategoryList.map(
                                        (item) => ({
                                            label: item.label,
                                            value: item.value,
                                        })
                                    ),
                                ]}
                                showSearch
                                filterOption={(input, option) =>
                                    !(option == null) &&
                                    option?.label
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Designation"
                            name="designationId"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Input Your Designation!',
                                },
                            ]}
                        >
                            <Select
                                onChange={handleDesignationchanage}
                                allowClear
                                placeholder="Please select"
                                options={[
                                    { label: 'Please select', value: null },
                                    ...designationDropDownList,
                                ]}
                                showSearch
                                filterOption={(input, option) =>
                                    !(option == null) &&
                                    option?.label
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="First Name"
                            name="firstName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Input Your First Name!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Middle Name"
                            name="middleName"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Surname"
                            name="surName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Input Your Surname!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Date of Birth"
                            name="dateOfBirth"
                            rules={[
                                {
                                    required: true,
                                    // message: 'Please Input Date of Birth!',
                                },
                                {
                                    validator: async (_, value) => {
                                        if (
                                            value !== null &&
                                            value !== undefined
                                        ) {
                                            await Promise.resolve()
                                            return
                                        }
                                        return await Promise.reject(
                                            new Error(
                                                'Please select  Date of Birth'
                                            )
                                        )
                                    },
                                },
                            ]}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    onChange={(date, dateString) => {
                                        onChange(date, dateString)
                                    }}
                                    value={
                                        selectedDate?.length > 0
                                            ? dayjs(selectedDate)
                                            : null
                                    }
                                    className={commonStyles.dateWidth}
                                    disabledDate={(current) => {
                                        // Disable dates after today
                                        return (
                                            current !== null &&
                                            current > dayjs().endOf('day')
                                        )
                                    }}
                                    allowClear
                                    format={'DD/MM/YYYY'}
                                />
                            </Space>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Address One"
                            name="addressOne"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Input Address 1!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Address Two"
                            name="addressTwo"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Town"
                            name="town"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Input Your Town!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Country"
                            name="country"
                        >
                            <Select
                                allowClear
                                showSearch
                                placeholder="Please select"
                                onChange={() => {}}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.label ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                options={countryList?.map((country) => ({
                                    value: country?.label,
                                    label: country?.label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <PostCodeInput
                            name="postCode"
                            label="Post Code"
                            reuireMessage="Please Enter Post Code"
                            placeHolder={''}
                            setAddressDetails={setAddress}
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Email"
                            name="emailAddress"
                            rules={[
                                {
                                    type: 'email',
                                    required: true,
                                    message: 'Please Input Your Email!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Nick Name"
                            name="userName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter Nick Name!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Contact No"
                            name="contactNo"
                            rules={[
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        'Please Enter a Valid Mobile Number (10 to 15 digits).',
                                },
                                {
                                    required: true,
                                    message: 'Please Input Your Mobile Number!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Reporting Person"
                            name="managerId"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Please Enter Reporting Person Name!',
                                },
                            ]}
                        >
                            <Select
                                allowClear
                                showSearch
                                placeholder="Please select"
                                onChange={handleManagerChange}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option?.label
                                        ?.toLowerCase()
                                        .includes(input.toLowerCase()) ?? false
                                }
                                options={userList}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="User Group"
                            name="userGroupId"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Input User Group!',
                                },
                            ]}
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={() => {}}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    typeof option?.children === 'string' &&
                                    (option.children as string)
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                <Select.Option value={null}>
                                    Please select
                                </Select.Option>
                                <Select.Option value={1}>
                                    Super Admin
                                </Select.Option>
                                <Select.Option value={2}>Admin</Select.Option>
                                <Select.Option value={3}>Manager</Select.Option>
                                <Select.Option value={4}>
                                    Employee
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item<ManageUserDetailsFormDataInterface>
                            label="Image"
                            name="imageUrl"
                        >
                            <S3Upload
                                name={'imageUrl'}
                                value={form.getFieldValue('imageUrl')}
                                setFormData={setFormData}
                                corporate={''}
                                corporateid={0}
                                documenttype={''}
                                documentbaseId={0}
                                memberpersonId={0}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {ActivePremission('9000', PermissionType.SAVE) && (
                    <Row gutter={16}>
                        <Col offset={21} span={2}>
                            <Tooltip title="Save">
                                <Button
                                    type="primary"
                                    onClick={saveuserInformationData}
                                    loading={Boolean(isLoadingModal)}
                                >
                                    <SaveOutlined />
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                )}
            </Form>
        </div>
    )
}

const mapStateToProps = (state: any): UserINFOFormStateInterface => {
    return {
        countryList: state.common.countryList,
        userList: state.user.userList,
        categoryDropDownList: state.initial.categoryDropDownList,
        departmentDropDownList: state.userrights.departmentDropDownList,
        designationDropDownList: state.userrights.designationDropDownList,
        dynamicClientCategoryList: state.common.dynamicClientCategoryList,
    }
}

export default connect(mapStateToProps)(UserInfoForm)
